import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import App from './App.jsx'
import { AppProvider } from './Context/Store.jsx'
//import {BrowserRouter} from "react-router-dom"

createRoot(document.getElementById('outer-wrapper')).render(
  
  // <BrowserRouter future={{ v7_startTransition: true }}></BrowserRouter>
  <StrictMode> 
    <AppProvider>
      <App /> 
    </AppProvider>
  </StrictMode>
  ,
)
